import { render, staticRenderFns } from "./SearchService.vue?vue&type=template&id=0866948a&scoped=true&"
import script from "./SearchService.vue?vue&type=script&lang=js&"
export * from "./SearchService.vue?vue&type=script&lang=js&"
import style0 from "./SearchService.vue?vue&type=style&index=0&id=0866948a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0866948a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
